module.exports = __webpack_public_path__ + "static/img/HOME-3.395f6fff.jpg";